"use client";

import React from 'react';
import { useLocale } from "@/content/i18n/context";
import { t } from "@/content/i18n/messages";

export interface ServiceStepListProps {
  steps: {
    title: string;
    description: string;
  }[];
  className?: string;
}

export default function ServiceStepList({
  steps,
  className = ''
}: ServiceStepListProps) {
  const locale = useLocale();
  const translate = (text: string) => t(locale, text);

  return (
    <div className={`rounded-2xl border border-border bg-card p-6 ${className}`}>
      <ol className="space-y-4">
        {steps.map((step, index) => (
          <li key={index} className="flex items-start">
            <div className="mr-8 mt-1 flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-primary/10">
              <span className="font-mono text-sm font-bold text-primary">{index + 1}</span>
            </div>
            <div>
              <h5 className="mb-1 font-semibold text-neutral-emphasis">{translate(step.title)}</h5>
              <p className="text-neutral-muted">{translate(step.description)}</p>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}
